import { Buildings, CalendarBlank } from "@phosphor-icons/react";

export default function GrantHeader({ title, agency, opNumber, status, openDate, closeDate }) {
  return (
    <>
      <div className="flex flex-wrap items-center gap-2 text-xs font-mono">
        <span className="text-zinc-500">{opNumber}</span>
        <span className="gf-overline">{agency}</span>
        {status && (
          <span className="px-2 py-0.5 bg-zinc-100 border border-zinc-200 uppercase">{status}</span>
        )}
      </div>
      <h1
        className="font-display font-black text-3xl sm:text-4xl tracking-tight mt-3"
        data-testid="grant-title"
      >
        {title}
      </h1>
      <div className="flex flex-wrap gap-4 mt-3 text-xs font-mono text-zinc-500">
        <div className="flex items-center gap-1"><Buildings size={14} /> {agency}</div>
        {openDate && (
          <div className="flex items-center gap-1"><CalendarBlank size={14} /> Posted {openDate}</div>
        )}
        {closeDate && (
          <div className="flex items-center gap-1"><CalendarBlank size={14} /> Closes {closeDate}</div>
        )}
      </div>
    </>
  );
}
